import { Logger, toDollars } from '@wolfdanepug/common-react'

export const multiDogMessage = (items: any = []) => {
	return items.reduce((acc: string, plan: any, index: number) => {
		const dailyPrice = toDollars(plan?.price / 14)
		const name = plan?.meta?.name
		if (index === 0) {
			acc += `${name}'s at $${dailyPrice} per day`
		} else if (index === items.length - 1) {
			acc += ` and ${name}'s at $${dailyPrice} per day`
		} else {
			acc += `, ${name}'s at $${dailyPrice} per day`
		}
		return acc
	}, '')
}

export const planMessage = (cart: any) => {
	if (cart?.items?.length === 1) {
		Logger.log('planMessage', cart)
		const plan: any = cart.items[0]
		const dailyPrice = toDollars(plan?.price / 14)
		return `Preportioned daily meals for ${plan.meta?.name}'s diet, at $${dailyPrice} per day.`
	}
	return `Preportioned daily meals for your dogs diet. ${multiDogMessage(cart?.items)}.`
}
